import { Injectable } from '@angular/core';
import { differenceInMinutes, format, parse } from 'date-fns';
import { collection, getDocs, getFirestore, limit, orderBy, query, where, Timestamp } from 'firebase/firestore';
import { FirebaseService } from '../commons/firebase.service';
import { TimeNegotiationValidate } from '../validators/time-negotiation';
import { observable, Observable, throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(public firebase: FirebaseService) { }

  async getRecentNegotiations() {
    const firestore = getFirestore(this.firebase.app);
    const today = Timestamp.now()
    const sevenDaysAgo = Timestamp.fromMillis(
      today.toMillis() - 7 * 24 * 60 * 60 * 1000
    );

    const q = query(collection(firestore, 'negociacoes'),
      where('data_fim', '>=', format(sevenDaysAgo.toDate(), 'yyyy-MM-dd 00:00:00')),
      where('status', '==', 'ativo'),
      orderBy('data_fim', 'desc'),
      orderBy('data_inicio', 'desc'),
      limit(10));

    const querySnapshot = await getDocs(q);

    // Converter o snapshot em um array de documentos
    const negociacoes = [];
    querySnapshot.forEach((doc) => {
      const negotiation = { ...doc.data(), id: doc.id }
      negociacoes.push(negotiation);
    });
    const negotiations = []
    negociacoes.map(e => {
      const restTime = this.tempoRestante(e)
      if (restTime === 'negociacao_expirada') return;
      const negotiation: any = e;
      if (e?.produto && e?.comprador && e?.status == 'ativo') {
        const { ean, nome, imagens, keywords } = e?.produto;
        const { estado, cidade, cep } = e?.comprador?.endereco_principal;
        negotiation.id = e.id;
        negotiation.uid = e.id;
        negotiation.nomeProduto = nome;
        negotiation.ean = ean;
        negotiation.imagemProduto = imagens[0]?.url;
        negotiation.comprador = e.comprador.uid;
        negotiation.estado = estado;
        negotiation.cidade = cidade;
        negotiation.cep = cep;
        negotiation.keywords = keywords;
        delete negotiation.duracao;
        delete negotiation.produto;
        negotiations.push(negotiation);
      } else {
        return null;
      }
    })

    return negotiations.sort((a: { data_fim: string }, b: { data_fim: string }) => new Date(a?.data_fim).getTime() - new Date(b.data_fim).getTime());

  }
  tempoRestante(negociacao: any): string {
    // Verifica se a negociação está definida e se possui uma data de término
    if (!negociacao || !negociacao.data_fim) {
      return 'Data de término não definida';
    }


    return TimeNegotiationValidate.validate(negociacao);
  }
  async getAllBoxes() {
    const firestore = getFirestore(this.firebase.app);
    const q = query(collection(firestore, 'boxes'))
    const querySnapshot = await getDocs(q);
    const boxes = [];
    querySnapshot.forEach((doc) => {
      const box = { ...doc.data(), id: doc.id }
      boxes.push(box);
    });

    return boxes;
  }

  getCurrentPosition(): Observable<GeolocationPosition> {
    return new Observable((observable) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            observable.next(position);
            observable.complete();
          },
          (error: GeolocationPositionError) => {
            observable.error(error);
          }
        );
      } else {
        observable.error(throwError(() => new Error('Geolocalização não é suportada pelo navegador.')))
      }
    })
  }
}


